import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ChartCardContainer from './ChartCardContainer';
import GlassTable from './GlassTable';
import LineAverageChart from './LineAverageChart';
import { useMaterialGeneral, useMaterialRecentDaily, useMaterialRollingAverage } from '../../hooks';
import { formatCurrency, formatUnit } from '../../utils/formatUnit';

const TableAndAverage = ({ materialCode }) => {
  const { t } = useTranslation();
  // Fetch recent daily prices from API
  const { data: recentDaily, loading: loadingDaily } = useMaterialRecentDaily(materialCode);

  // Fetch rolling average data from API
  const { data: rollingAverage, loading: loadingAverage } = useMaterialRollingAverage(materialCode);
  const { data: materialGeneral } = useMaterialGeneral(materialCode);

  // Use API data if available, otherwise use default data
  const baseTableData = recentDaily || [
    { date: '26.04.2025', change: -1.65, price: 3670.35 },
    { date: '26.04.2025', change: -1.65, price: 3670.35 },
    { date: '26.04.2025', change: -1.65, price: 3670.35 },
    { date: '26.04.2025', change: -1.65, price: 3670.35 },
    { date: '26.04.2025', change: -1.65, price: 3670.35 },
  ];

  // Table should display latest date first (top -> bottom).
  const tableData = useMemo(() => {
    const parseDate = (value) => {
      if (!value || typeof value !== 'string') return Number.NEGATIVE_INFINITY;
      const m = value.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
      if (!m) return Number.NEGATIVE_INFINITY;
      const [, dd, mm, yyyy] = m;
      return new Date(`${yyyy}-${mm}-${dd}T00:00:00Z`).getTime();
    };

    return [...baseTableData].sort((a, b) => parseDate(b?.date) - parseDate(a?.date));
  }, [baseTableData]);

  // /general liefert ohne Waehrung "n/a": dann nur die Einheit anzeigen
  const currency = formatCurrency(materialGeneral?.currency) || null;
  const unit = formatUnit(materialGeneral?.value_unit) || null;

  return (
    <ChartCardContainer title={t("charts.section.tableAverage")}>
      <div className="table-average-layout">
        {/* Left side - Data Table (Recent Daily Prices) */}
        <div className="table-section">
          <GlassTable
            rows={tableData}
            title=""
            currency={currency}
            unit={unit}
          />
        </div>

        {/* Right side - Weekly Average Chart (Rolling Averages) */}
        <div className="chart-section">
          <LineAverageChart
            rollingData={rollingAverage}
            currency={currency}
            unit={unit}
          />
        </div>
      </div>
    </ChartCardContainer>
  );
};

export default TableAndAverage;
